// extracted by mini-css-extract-plugin
export default {"containerCabinet":"MetaData_containerCabinet__sEV+U"};